import { render } from "./root.vue?vue&type=template&id=3099c6c4&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3099c6c4"

export default script